import { render, staticRenderFns } from "./ClientDetailView.vue?vue&type=template&id=6bfedb72"
import script from "./ClientDetailView.vue?vue&type=script&lang=js"
export * from "./ClientDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports